export default __webpack_public_path__ + "static/media/usd_flag.b63441c8.png";